import { ImageIcon } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

type Props = { src?: string; alt: string; isPlaceholder?: boolean; className?: string; imgClassName?: string; loading?: "lazy" | "eager"; testId?: string };

export const SmartImage = ({ src, alt, isPlaceholder, className = "", imgClassName = "", loading = "lazy", testId }: Props) => {
  const { t } = useLanguage();
  return (
    <div className={`relative overflow-hidden bg-sand-100 ${className}`} data-testid={testId}>
      {src ? (
        <img src={src} alt={alt} loading={loading} decoding="async" className={`h-full w-full object-cover ${imgClassName}`} />
      ) : (
        <div className="flex h-full w-full flex-col items-center justify-center gap-2 text-charcoal-400" role="img" aria-label={alt}>
          <ImageIcon className="h-8 w-8" aria-hidden />
          <span className="text-xs font-medium">{t.common.imageMissing}</span>
        </div>
      )}
      {isPlaceholder && (
        <span className="absolute left-3 top-3 rounded-full bg-charcoal/70 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider text-cream backdrop-blur" title={t.common.placeholderImage}>
          {src ? "Platzhalter" : t.common.imageMissing}
        </span>
      )}
    </div>
  );
};
